import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { useSelector } from 'react-redux';
import Notification, { showToast } from "../../../components/common/notification/Notification";
import Api from "../../components/api/Api";
import UserProfile from "./UserProfile";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const UserPayment = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;
  
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const razorpay_key = process.env.REACT_APP_RAZORPAY_KEY;
  // console.log("Razorpay Key from env:", razorpay_key);

  const navigate = useNavigate();

  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [expandedPlan, setExpandedPlan] = useState(null);
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);

  const getDetailsApi = Api({ url: `admin/user/id/${userId}`});
  useEffect(() => {
    fetchPlans();
    fetchUserDetails();
  }, []);

  const fetchPlans = async () => {
    try {
      const { data } = await axios.get(`${baseUrl}/payments/subscriptions/plan`);
      console.log(data)
      if (data.statusType === 'SUCCESS') {
        const updatedPlans = data.subscriptionPlans.map(plan => ({
          ...plan,
          total_price: plan.total_price + 200,
          original_price: plan.total_price,
        }));
        setPlans(updatedPlans);
        if (updatedPlans.length > 0) {
          setSelectedPlan(updatedPlans[0].id);
        }
      } else {
        showToast('Failed to fetch plans', {type: 'error'})
      }
    } catch (err) {
      showToast('Unable to fetch subscription plans', {type: 'error'})
    }
    console.log('selected plan:', selectedPlan);
  };

  const fetchUserDetails = async () => {
    try {
      const responseData = await getDetailsApi.fetchData(); 
      const user = responseData?.data;
      setUserDetails(user.user);
      // console.log("User Details:", userDetails);
    } catch (error) { 
      console.error("Error fetching data:", error);
    }
  };
  
  const togglePlanDetails = planId => {
    setExpandedPlan(prev => (prev === planId ? null : planId));
  };

  const fetchOrderId = async () => {
    setApiLoading(true);
    try {
      const payload = {
        user_id: userId.toString(),
        rating: 0,
        subscription_plan_id: selectedPlan,
        is_registration: true,
      };
      // console.log('Order ID payload:', payload);

      const response = await axios.post(`${baseUrl}/payments/getRazorPaymentOrderId`, payload);
      // console.log('Order ID response:', response);
      if (response.data.statusType === 'SUCCESS') {
          // console.log('Order ID and amount:', response.data.orderId, response.data.amount.toString())
          // set on local host the amount
          localStorage.setItem("paymentAmount", response.data.amount);
        return { 
          orderId: response.data.orderId, 
          amount: response.data.amount.toString()
        }; 
      } else {
        showToast('Order ID fetch failed', {type: 'error'})
        return null;
      }
    } catch (err) {
      console.error('Order ID error:', err);
      showToast('Network error. Try again.', {type: 'error'})
      return null;
    } finally {
      setApiLoading(false);
    }
  };

  const handlePayment = async () => {
    setLoading(true);
    try {
      const result = await fetchOrderId();
      if (!result) return;

      const options = { 
        key: razorpay_key,
        // key: 'rzp_test_R4Ug5dZS4kiRIY',
        amount: result.amount,
        currency: 'INR',
        name: 'Ushma Infotech Private Limited',
        description: 'Payment for subscription',
        order_id: result.orderId,
        handler: async response => {
          try {
            const verifyPayload = {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            };
            console.log('Payment response:', response);
            console.log('Payment verifyPayload:', verifyPayload);
            const verifyResponse = await axios.put(`${baseUrl}/payments/saveAndVerifyPayment`, 
              verifyPayload
            );
            console.log('Payment verification response:', verifyResponse);
            if (verifyResponse.data.statusType === 'SUCCESS') {
              navigate('/user/upload-payment-screen-shot', {
                state: {
                  message: 'Payment Successful',
                  paymentDetails: verifyPayload,
                  userId: userDetails.partner_id,
                  razorpayPaymentId: response.razorpay_payment_id,
                },
              });
            } else {
              showToast(verifyResponse.data.text || 'Payment verification failed', {type: 'error'})
            }
          } catch (err) {
            console.error('Verification error:', err);
            showToast('Payment verification failed', {type: 'error'})
          }
        },
        prefill: {
          name: `${userDetails.first_name} ${userDetails.last_name}`.trim(),
          email: userDetails.email_address,
          contact: userDetails.mobile_number,
        },
        theme: {
          color: '#0d6efd',
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', response => {
        showToast('Payment failed. Please try again.', {type: 'error'})
      });
      rzp.open();
    } catch (err) {
      console.error('Payment error:', err);
      showToast('Payment failed.', {type: 'error'})
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Profile", link: "/user/profile" },
    { label: "Edit User Profile", link: "", active: true },
  ];
  return (
    <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem"  }}>
      <Notification/>
      <BreadCrumb items={breadcrumbItems} />
      
      <Row>
        <Col md={4}>
          <UserProfile />
        </Col>
        <Col md={6} className="mx-auto">
          {apiLoading && (
            <div className="text-center py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {/* <h2 className="text-center mb-2">Choose a Subscription Plan</h2> */}
          <div className="accordion" id="plansAccordion">
            {plans.map((plan) => (
              <div className="accordion-item" key={plan.id}>
                <h2 className="accordion-header" id={`heading-${plan.id}`}>
                  <button
                    className={`accordion-button d-flex justify-content-between align-items-center ${
                      expandedPlan === plan.id ? '' : 'collapsed'
                    } ${selectedPlan === plan.id ? 'bg-light border-start border-4 border-primary' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${plan.id}`}
                    aria-expanded={expandedPlan === plan.id}
                    aria-controls={`collapse-${plan.id}`}
                    onClick={() => {
                      togglePlanDetails(plan.id);
                      setSelectedPlan(plan.id);
                    }}
                  >
                    <div>
                      <h6 className="mb-0">{plan.duration_in_days} Days</h6>
                      {/* <small className="text-success">🎁 +{plan.duration_in_days} Days Free</small> */}
                    </div>
                    <div className="text-end ms-auto">
                      <h6 className="mb-0 fw-semibold text-primary">
                        ₹{plan.total_price.toLocaleString('en-IN')}
                      </h6>
                      <small className="text-muted">Including GST</small>
                    </div>
                  </button>
                </h2>

                <div
                  id={`collapse-${plan.id}`}
                  className={`accordion-collapse collapse ${expandedPlan === plan.id ? 'show' : ''}`}
                  aria-labelledby={`heading-${plan.id}`}
                  data-bs-parent="#plansAccordion"
                  >
                  <div className="accordion-body bg-light">
                    <div className="d-flex justify-content-between mb-2">
                      <span>Subscription Price:</span>
                      <span>₹{plan.price.toLocaleString('en-IN')}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>GST (18%):</span>
                      <span>₹{plan.gst.toLocaleString('en-IN')}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span>Registration Fee:</span>
                      <span>₹200</span>
                    </div>
                    <hr className="my-2" />
                    <div className="d-flex justify-content-between fw-bold">
                      <span>Total Amount:</span>
                      <span>₹{plan.total_price.toLocaleString('en-IN')}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            className="btn btn-outline-success w-100 mt-4"
            onClick={handlePayment}
            disabled={loading || !selectedPlan}
          >
            {loading ? 'Processing...' : 'Continue to Payment'}
          </button>
        </Col>
      </Row>

    </Container>  
  );
}; 

export default UserPayment;